import React from "react";

function Terms() {
  return (
    <div className="terms-section">
      <div className="container">
        <div className="terms-text">
          <h2>Terms Of Services</h2>
         <p className="mb-0">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Est odio
          inventore quaerat nesciunt dignissimos quo accusamus porro temporibus
          itaque ducimus nobis officia architecto soluta, cumque corrupti, ut
          quas. Reprehenderit incidunt delectus ab sit voluptates dolores,
          officia minus reiciendis sed error officiis maiores consequatur odit
          nisi repellat eaque consequuntur mollitia aspernatur corporis cumque
          in nam. Aspernatur, voluptas eum. Dicta reiciendis ab natus assumenda!
          Autem quos totam nobis recusandae quae alias, ut, aliquid ex sed, nam
          amet pariatur reiciendis? Distinctio modi, qui labore molestias
          tenetur saepe quaerat dolorem! Voluptatibus omnis doloribus, placeat
          quod cum officia obcaecati impedit quam in delectus, alias
          repudiandae.
        </p><br />
         <p className="mb-0">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Est odio
          inventore quaerat nesciunt dignissimos quo accusamus porro temporibus
          itaque ducimus nobis officia architecto soluta, cumque corrupti, ut
          quas. Reprehenderit incidunt delectus ab sit voluptates dolores,
          officia minus reiciendis sed error officiis maiores consequatur odit
          nisi repellat eaque consequuntur mollitia aspernatur corporis cumque
          in nam. Aspernatur, voluptas eum. Dicta reiciendis ab natus assumenda!
          Autem quos totam nobis recusandae quae alias, ut, aliquid ex sed, nam
          amet pariatur reiciendis? Distinctio modi, qui labore molestias
          tenetur saepe quaerat dolorem! Voluptatibus omnis doloribus, placeat
          quod cum officia obcaecati impedit quam in delectus, alias
          repudiandae.
        </p><br />
        <p className="mb-0">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Est odio
          inventore quaerat nesciunt dignissimos quo accusamus porro temporibus
          itaque ducimus nobis officia architecto soluta, cumque corrupti, ut
          quas. Reprehenderit incidunt delectus ab sit voluptates dolores,
          officia minus reiciendis sed error officiis maiores consequatur odit
          nisi repellat eaque consequuntur mollitia aspernatur corporis cumque
          in nam. Aspernatur, voluptas eum. Dicta reiciendis ab natus assumenda!
          Autem quos totam nobis recusandae quae alias, ut, aliquid ex sed, nam
          amet pariatur reiciendis? Distinctio modi, qui labore molestias
          tenetur saepe quaerat dolorem! Voluptatibus omnis doloribus, placeat
          quod cum officia obcaecati impedit quam in delectus, alias
          repudiandae.
        </p><br />
        <p className="mb-0">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Est odio
          inventore quaerat nesciunt dignissimos quo accusamus porro temporibus
          itaque ducimus nobis officia architecto soluta, cumque corrupti, ut
          quas. Reprehenderit incidunt delectus ab sit voluptates dolores,
          officia minus reiciendis sed error officiis maiores consequatur odit
          nisi repellat eaque consequuntur mollitia aspernatur corporis cumque
          in nam. Aspernatur, voluptas eum. Dicta reiciendis ab natus assumenda!
          Autem quos totam nobis recusandae quae alias, ut, aliquid ex sed, nam
          amet pariatur reiciendis? Distinctio modi, qui labore molestias
          tenetur saepe quaerat dolorem! Voluptatibus omnis doloribus, placeat
          quod cum officia obcaecati impedit quam in delectus, alias
          repudiandae.
        </p>  
        </div>
       
      </div>
    </div>
  );
}

export default Terms;
